import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { NotificationModel } from '../../models/notification.model';
import { NotificationsService } from '../../services/notifications.service';

@Component({
    selector: 'sl-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotificationsComponent implements OnInit {
    isLoading = true;
    showRead = false;
    numberOfDays: number;
    notifications: NotificationModel[] = [];
    displayedColumns = ['createdDate', 'subject', 'message', 'confirm', 'action'];

    private readonly notificationsService = inject(NotificationsService);

    constructor() {
        this.numberOfDays = this.notificationsService.maxDays;
    }

    ngOnInit(): void {
        this.fetchNotifications();
    }

    markAsRead(notification: NotificationModel): void {
        this.isLoading = true;
        this.notificationsService.markAsConfirmed(notification.id).subscribe(() => {
            this.fetchNotifications();
        });
    }

    showReadChanged(event: MatSlideToggleChange): void {
        this.showRead = event.checked;
        this.fetchNotifications();
    }

    private fetchNotifications(): void {
        this.isLoading = true;
        this.notificationsService.getNotifications(this.showRead).subscribe(notifications => {
            this.isLoading = false;
            this.notifications = notifications;
        });
    }
}
